// extracted by mini-css-extract-plugin
export default {"cta":"JH-z","disabled":"KH-z"};